import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import useFetchURL from "../../../components/Hooks/useFetchURL";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import HashLoader from "react-spinners/HashLoader";
import { colors, Container, Dialog, Modal } from "@material-ui/core";
import LoadingPage from "../../../services/LoadingPage";
import SalesDetails from "../../Sales/BackEnd/Tab1Rout/SalesDetailsReprot/SalesDetails";
const defaultAutos = {
  types: [],
};

export default function PurchaseDetailsCon() {

  const [branch, setBranch] = useState({ id: -1, name: "الكل" });
  const [valueType, setValueType] = useState({ id: -1, name: "الكل" });
  const tb = {
    Customers: true,
    Branches: true,
    types: true,
    costcenters: true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },
    parms: {
      type: -1,
      branch: branch.id == -1 ? sto.branchi : branch.id,
      iempid: sto.empi,
      db_name: sto.db_name
    },
  };
  let Urls = null;
  if (sto.db_name === "" || sto.db_name === null) {
    Urls = `/custm?t=${2}`
  } else {
    Urls = `/custm?t=${2}&&db_name=${sto?.db_name}`
  }
  const url = uri + "Auto" + Urls;
  const { data: CustomerOptions, fetching: fetchCust } = useFetchURL({
    ...{ url, dependencyArray: [] },
  });
  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "Rept",
    tb,
    [branch],
    [valueType],
  );

  if (
    fetchCust ||
    fetchAll ||
    CustomerOptions?.length == 0
  )
    return <LoadingPage />;

  return (
    <SalesDetails
      {...{
        AutoOptions: AutoOptions?.types ? AutoOptions : defaultAutos,
        CustomerOptions: CustomerOptions?.length > 0 ? CustomerOptions : [],
        branch,
        setBranch,
        valueType,
        setValueType,
        isPurches: true,
      }}
    />
  );
}
